import React, { useEffect, useState } from "react";
import { differenceInMinutes } from "date-fns";
import { getTimeDifference } from "@sscs/utils";

type TimeStatusProps = {
  timestamp: string;
  wholeDays?: boolean;
};

const TimeStatus = ({
  timestamp,
  wholeDays = false,
}: TimeStatusProps): React.JSX.Element => {
  const [timeString, setTimeString] = useState(
    getTimeDifference(timestamp, wholeDays),
  );

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined = undefined;

    /* If more than an hour passed, no need to provide real time updates */
    if (differenceInMinutes(new Date(timestamp), new Date()) <= 60) {
      setTimeString(getTimeDifference(timestamp, wholeDays));

      interval = setInterval(() => {
        setTimeString(getTimeDifference(timestamp, wholeDays));
      }, 61 * 1000); // ensures more than a minute passes to ensure UI shows the next number
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [timestamp, wholeDays]);

  return <span title={new Date(timestamp).toString()}>{timeString}</span>;
};

export default TimeStatus;
